export class DeviceModel {
  type: number
  device_id: string
  push_token: string
  os_version: string
  app_version: string
  make: string
  model: string
  active: boolean

  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/main/authentication/models/device.model.ts